import { CehrLissageRequest, CehrSimulationRequest } from '../models/cehr-simulation-request';
import {
  CehrDisplayedResult,
  CehrLissageResponse,
  CehrSimulationResponse,
} from '../models/cehr-simulation-response.model';

export function buildLissageRequest(
  simulationResponse: Partial<CehrSimulationResponse>,
  simulationRequest: Partial<CehrSimulationRequest>,
  payload: { rfrNMinus1: number | undefined; rfrNMinus2: number | undefined },
): CehrLissageRequest {
  return {
    fiscalSituation: simulationRequest.fiscalSituation ?? 'SINGLE',
    currentRfr: simulationResponse.rfrUsed ?? 0,
    cehrBeforeSmoothing: simulationResponse.cehrAmount ?? 0,
    rfrNMinus1: payload.rfrNMinus1 ?? 0,
    rfrNMinus2: payload.rfrNMinus2 ?? 0,
  };
}

export function mapCehrSimulationResponseToDisplayed(
  resp: CehrSimulationResponse,
): CehrDisplayedResult {
  return {
    source: 'CEHR',
    rfrUsed: resp.rfrUsed ?? 0,
    cehrAmount: resp.cehrAmount ?? 0,
    breakdown: { lines: resp.taxBreakdown?.lines ?? [] },
    maxSavingAmount: resp.maxSavingAmount ?? 0,
    suggestionCodes: resp.suggestionCodes ?? [],
    liableforCEHR: resp.liableforCEHR,
  };
}

export function applyLissageToDisplay(
  base: CehrDisplayedResult,
  lissage: CehrLissageResponse,
): CehrDisplayedResult {
  return {
    ...base,
    source: 'LISSAGE',
    cehrAmount: lissage.cehrAfterSmoothing ?? base.cehrAmount,
    breakdown: lissage.afterBreakdown ?? base.breakdown,
    message: lissage.message,
    savingAmount: lissage.savingAmount,
    eligible: lissage.eligible,
  };
}
